/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:26:39
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:32:56
 */
import { unwrapResult } from "@reduxjs/toolkit";
import { notification, Pagination, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import {
  AccountStationParams,
} from "../../services/AccountStation";
import { AccountColumns } from "./AccountColumns";
import { AccountModal } from "./AccountModal";
import { AccountQuery } from "./AccountQuery";
import {
  AccountStationChangeAsync,
  getAccountStationAsync,
  selectAccountData,
  setAccountId,
} from "./AccountSlice";
import styles from "./AccountStation.module.css";

export const AccountStation = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [IsVisible, setIsVisible] = useState(false);

  const [queries, setQueries] = useState<AccountStationParams>({
    pn: 1,
    ps: 10,
  });

  const data = useSelector(selectAccountData);

  useEffect(() => {
    if (JSON.stringify(queries) !== "{}") {
      dispatch(getAccountStationAsync({ ...queries}));
    }
  }, [queries]);
  return (
    <div className={styles.AccountStation}>
      <div
        style={{
          height: "100px",
          marginBottom: "10px",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <h3 style={{ fontWeight: "bold" }}>查询条件</h3>
        <AccountQuery
          onValueChange={(v) => {
            setQueries({...v, pn: 1,ps: 10,});
          }}
          save={() => {
            setIsVisible(true);
          }}
        />
      </div>
      <div
        style={{
          height: "calc(100% - 55px)",
          overflow: "auto",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <Table
          style={{
            height: "calc(100% - 105px)",
          }}
          rowKey={(record) => record.userId}
          className={styles.AccountTable}
          pagination={false}
          columns={AccountColumns(data.size * (data.current - 1), (userId, t,userName) => {
            if (t === "edit") {
              dispatch(setAccountId(userId));
              setIsVisible(true);
            } else if (t === "change") {
              dispatch(AccountStationChangeAsync(userId))
                .then(unwrapResult)
                .then(()=>{
                  notification.success({
                    message: "操作成功",
                    duration: 3,
                  });
                })
                .then(() => {
                  dispatch(getAccountStationAsync(queries));
                });
            }
          })}
          dataSource={data.records}
        ></Table>
      </div>
      <Pagination
         total={data.total}
         current={data.current}
         pageSize={data.size}
        showSizeChanger
        showQuickJumper
        style={{
          position: "absolute",
          bottom: "40px",
          right: "40px",
        }}
        showTotal={(total) => `共 ${total} 条`}
        onChange={(current, size) => {
          setQueries({ ...queries,  pn:current,  ps:size });
        }}
      />
      <AccountModal
        visible={IsVisible}
        onCancel={() => {
          setIsVisible(false);
          dispatch(setAccountId(0));
        }}
        onOk={() => {
          setIsVisible(false);
          dispatch(setAccountId(0));
          dispatch(getAccountStationAsync({ ...queries, }));
        }}
      />
    </div>
  );
};
